import { inject } from '@angular/core';
import { DateHelper } from '@shared/helpers';
import { ScheduleLockApiService } from '@shared/services';
import { PopoverConfig, PopoverHandlerConfig } from '../generic-popover.interfaces';
import { defaultCancelAction, defaultConfirmAction } from './default-actions';

export const taAvailabilityScheduleLockPopoverConfig = (
  onSuccess: () => void,
  onCancel: () => void,
  actionHandlers?: Record<string, (popoverConfig: PopoverHandlerConfig, formValue: any) => void | Promise<any>>
): PopoverConfig => {
  const scheduleLockApiService = inject(ScheduleLockApiService);

  return {
    width: '300px',
    title: 'Khóa/Mở lịch',
    dismissable: true,
    styleClass: 'p-fluid',
    formConfig: {
      fields: [
        {
          key: 'date', label: 'Tuần của ngày', required: true, width: 'full',
          type: 'datepicker', placeholder: 'Chọn tuần của ngày (Mon-Sun)'
        },
        { key: 'locked', label: '', type: 'text', width: 'full', hidden: true }
      ]
    },
    actions: [defaultCancelAction, defaultConfirmAction],
    actionHandlers,
    handlerConfig: {
      service: scheduleLockApiService,
      method: 'updateScheduleLock',
      entityLabel: 'khóa lịch',
      successMessage: 'Cập nhật khóa/mở lịch thành công',
      commonDataTransform: (formValue: any) => {
        const selectedDate = new Date(formValue.date);
        const weekRange = DateHelper.getWeekRange(selectedDate);
        return {
          fromDate: DateHelper.formatDateLocal(weekRange.from),
          toDate: DateHelper.formatDateLocal(weekRange.to),
          locked: !!formValue.locked
        };
      },
      initialDataTransform: (rawData: any) => ({
        date: rawData?.date ? new Date(rawData.date) : null,
        locked: !!rawData?.locked
      }),
      onSuccess,
      onCancel
    }
  };
};

